import { Component, OnInit, Input, Output, EventEmitter, AfterContentInit, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core'
import { OperationFile } from '../../models';
import { InputBaseComponent } from '../input-base.component';
import { HttpService } from '../../services/http.service';
import { InputFileTypeEnum } from '../../enums/input.file.enum';
import { breakpoints } from '../../environments/environment.breakpoints';

declare var $: any;

@Component({
  selector: 'ct-input-file',
  templateUrl: './ct-input-file.component.html',
  styleUrls: ['./ct-input-file.component.css']
})
export class CtInputFileComponent extends InputBaseComponent implements OnInit, AfterContentInit {

  @Output() filesChange = new EventEmitter();
  @ViewChild('el') formControl: ElementRef;

  private formats: string = '*';
  private maxFiles: number = 0;
  private minFiles: number = 0;
  private maxFileSize: number = 25;
  private files: any[] = [];
  private processedFiles: any[] = [];
  fullWidth = false;
  dragAndDrop: boolean;

  // v5 properties
  private type : InputFileTypeEnum = InputFileTypeEnum.Button;
  private wasValidated: boolean = false; //this property is used to change the button type input to green or default. 
  //when a action "onValidate" is executed, this property is set to true, and the button is changed to green. if the action is not given then it'll always be set to
  //green.
  private title : string;
  private description : string;

  // util
  public InputFileTypeEnum = InputFileTypeEnum;
  public isMediumSize : boolean = false;
  public isSmallSize : boolean = false;
  public isExtraSmall : boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.manageWindowResizing(window.innerWidth);
  }

  private manageWindowResizing(width: number) {
    this.isSmallSize = width < breakpoints.L && width >= breakpoints.M;
    this.isExtraSmall = width >= breakpoints.S && width < breakpoints.M;
    this.isMediumSize = width >= breakpoints.L;
  }

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (!this.getMetaData()) {
      this.setMetaData({
        id: "asd",
        ctType: "CtInputFile",
        controlProperties: {
          hidden: false,
          labelValue: null,
          oneLineControl: false,
          readOnly: false,
          value: null,
          required: false,
          requiredMessage: "Debe subir un archivo!",
          minFiles: 0,
          maxFiles: 0,
          maxFileSize: 25,
          formats: '*'
        },
        controlActions: [],
        models: []
      });
    }
    this.onResize();
  }

  ngAfterContentInit(): void {
    this.setProperties(this);
    setTimeout(() => {
      this.validInputFile();
    })
  }

  getClass() {
    const result = super.getEffectiveClass(this.isMediumSize, this.isSmallSize, this.isExtraSmall);
    return result;
  }

  // v5 functions
  public onButtonInputChange(eventFile : Event): void {
    const file = eventFile.target['files'][0];

    if(!file) return;

    this.files = [file];

    let event = this.getEvent('onFileValidate');
    if(event){
      this.executeAction2(event);
    }

    this.uploadFile(eventFile.target['files']);
    this.setWasValidated(true);

    event = this.getEvent('onPostValidation');
    if(event){
      this.executeAction2(event);
    }
  }

  public onButtonInputClick(eventFile : Event): void {
    if(this.getWasValidated()){
      eventFile.preventDefault();
      this.onButtonInputClear();
      return;
    }
  }

  public onButtonInputClear(): void {
    this.formControl.nativeElement.value = '';
    this.setWasValidated(false);
    this.files = [];
    this.resetToInitState();
    let event = this.getEvent('onAfterInputFileClear');
    if(event){
      this.executeAction2(event);
    }
  }

  // v4 functions
  public validInputFile() {
    let files = this.getFiles();

    if ((!files && !this.getRequired()) || (files && files.length >= this.getMinFiles()))
      this.getFormControl().nativeElement.valid = true;
    else
      this.getFormControl().nativeElement.valid = false;
  }

  private uploadFile(event: FileList): void {
    let files = this.getFiles();
    let updateLast = false;

    if (!files) {
      files = [];
      this.setFiles(files);
    }

    if ((this.getReadOnly() === true || Number(this.getReadOnly()) === 1)
        || !event || event.length === 0) return;

    for (let index = 0; index < event.length; index++) {
      if (files.length >= this.getMaxFiles())
        updateLast = true

      let file = event[index];

      if (this.getMaxFileSize() > 0 && file.size > (this.getMaxFileSize() * 1024 * 1024)) {
        continue;
      }

      if (this.getFormats() !== '*' || !this.getFormats()) {
        let extIndx = file.name.lastIndexOf('.');
        let fileFormat = file.name.substr(extIndx);

        if (extIndx === -1) {
          continue;
        }

        if (this.getFormats().toLowerCase().indexOf(fileFormat.toLowerCase()) === -1) {
          continue;
        }
      }

      let duplicated = files.filter(x => x.name === file.name)[0];

      if (duplicated) {
        let duplicatedIndx = files.indexOf(duplicated);
        files[duplicatedIndx] = file;
      } else {
        if (updateLast)
          files[((files.length - 1) < 0) ? 0 : (files.length - 1)] = file
        else
          files.push(file);

        this.setFiles(files);
      }
    }

    this.getFormControl().nativeElement.value = "";
    this.processFiles();
    this.validInputFile();
    this.event2('onChange');

  }

  private processFiles(): void {
    let files = this.getFiles();
    this.setProcessedFiles([]);
    files.forEach(x => this.getProcessedFiles().push(x));
    this.filesChange.emit(this.getProcessedFiles());
  }

  private getFileData(file: Blob): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  public deleteAttachment(index: number): void {
    this.getFiles().splice(index, 1)
    this.getProcessedFiles().splice(index, 1)
  }

  public resetToInitState(): void {
    super.resetToInitState();
    this.setProcessedFiles([]);
    this.setFiles([]);
    this.getFormControl().nativeElement.value = "";
  }

  public getJSON() {
    return '{"id":"asd","ctType":"CtInputFile","controlProperties":{"hidden":false,"labelValue":null,"oneLineControl":false,"readOnly":false,"value":null,"required":false,"requiredMessage":"Debe subir un archivo!","minFiles":0,"maxFiles":0,"maxFileSize":25,"formats":"*"},"controlActions":[],"models":[]}';
  }



  getFormats(): string { return this.formats }
  getMinFiles(): number { return this.minFiles }
  getMaxFiles(): number { return this.maxFiles }
  getMaxFileSize(): number { return this.maxFileSize }
  getFiles(): File[] { return this.files }
  getFormControl(): any { return this.formControl }
  getIsValid(): boolean { return this.getFormControl().nativeElement.valid }
  getDragAndDrop(): boolean { return this.dragAndDrop }
  getProcessedFiles(): any { return this.processedFiles }
  getFullWidth(): boolean { return this.fullWidth }

  // v5 getters and setters
  getType(): InputFileTypeEnum { return this.type }
  getWasValidated(): boolean { return this.wasValidated }
  getTitle(): string { return this.title }
  getDescription(): string { return this.description }

  setFormats(formats: string): void { this.formats = formats }
  setMinFiles(minFiles: number): void { this.minFiles = minFiles }
  setMaxFiles(maxFiles: number): void { this.maxFiles = maxFiles }
  setMaxFileSize(maxFileSize: number): void { this.maxFileSize = maxFileSize }
  setDragAndDrop(dragAndDrop): void { this.dragAndDrop = dragAndDrop }
  setFullWidth(fullWidth: boolean): void { this.fullWidth = fullWidth }
  private setFiles(files: any[]): void { this.files = files } 
  private setProcessedFiles(processedFiles: any[]): void { this.processedFiles = processedFiles }

  // v5 getters and setters
  setType(type: InputFileTypeEnum): void { this.type = type }
  setWasValidated(wasValidated: boolean): void { this.wasValidated = wasValidated }
  setTitle(title: string): void { this.title = title }
  setDescription(description: string): void { this.description = description }

}
